import { Directive, Input, ElementRef, HostBinding, Renderer2 } from '@angular/core';
import { LyShadowService } from './shadow.service';
import { LyTheme } from 'alyle-ui/core';
var LyDeepComponent = /** @class */ (function () {
    function LyDeepComponent(elementRef, renderer, theme, shadow) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.theme = theme;
        this.shadow = shadow;
        this._size = 1;
        this._interval = 3000;
        this.numberState = -1;
        this._shadowColor = 'rgba(0,0,0,0.87)';
        /** Default elevation */
        this.elevation = 1;
    }
    Object.defineProperty(LyDeepComponent.prototype, "lyShadow", {
        set: function (val) {
            this.shadow.setShadow(this.elementRef, this.renderer, val, this._lastClass);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyDeepComponent.prototype, "shadowColor", {
        get: function () {
            return this._shadowColor;
        },
        set: function (val) {
            this._shadowColor = this.theme.colorOf(val);
            this.styleHost();
        },
        enumerable: true,
        configurable: true
    });
    LyDeepComponent.prototype.styleHost = function () {
        this.styleBoxShadow = this.shadow.shadow(this.shadowColor, this.scale);
    };
    Object.defineProperty(LyDeepComponent.prototype, "scale", {
        get: function () {
            return this._size;
        },
        set: function (val) {
            this._size = val;
            this.styleHost();
        },
        enumerable: true,
        configurable: true
    });
    LyDeepComponent.decorators = [
        { type: Directive, args: [{
                    selector: '[ly-deep], [ly-shadow], [lyShadow]'
                },] },
    ];
    /** @nocollapse */
    LyDeepComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
        { type: LyTheme, },
        { type: LyShadowService, },
    ]; };
    LyDeepComponent.propDecorators = {
        "styleBoxShadow": [{ type: HostBinding, args: ['style.box-shadow',] },],
        "lyShadow": [{ type: Input },],
        "shadowColor": [{ type: Input, args: ['shadowColor',] },],
        "scale": [{ type: Input },],
    };
    return LyDeepComponent;
}());
export { LyDeepComponent };
//# sourceMappingURL=deep.js.map